import { updateSiteDataStore } from "../../utils/userDataStore";
import {
  ADD_TAB_HISTORY,
  REMOVE_TAB_HISTORY,
} from "../../constants/actionTypes";

export const addTabHistory = (name, tab, updateDataStore = true) => {
  return (dispatch, getState) => {
    let tabs = getState().siteEntranceExit[name].tabHistory.filter(
      (t) => t.eventGroupId === tab.eventGroupId
    );
    if (tabs.length === 0) {
      dispatch({
        type: ADD_TAB_HISTORY,
        name,
        tab,
      });
      if (updateDataStore) updateSiteDataStore(name, getState());
    }
  };
};

export const removeTabFromHistory = (name, index) => {
  return (dispatch, getState) => {
    dispatch({
      type: REMOVE_TAB_HISTORY,
      name,
      index,
    });
    updateSiteDataStore(name, getState());
  };
};
